import * as Http from '../api/http';
import * as ErrorActions from './errorActions';
import * as ActionCreators from './actionCreators';
import { methodConstants } from '../constants/methodConstants';
import * as CommonActions from './commonActions';
import { appConstants } from '../constants/appConstants';

const loginUser = {
  userName: '',
  password: ''
};

export const getUserName = (name) => () => {
  loginUser.userName = name;
};

export const getUserPassword = (password) => () => {
  loginUser.password = password;
};

export const submitLogin = () => (dispatch, getState) => {
  dispatch(ActionCreators.displayLoader(true));
  const loginData = {
    grant_type: appConstants.GRANT_TYPE_PASSWORD,
    username: loginUser.userName,
    password: loginUser.password,
    recaptcha_response: '',
    refresh_token: ''
  };
  const currentState = getState();
  const loginUrl = CommonActions.getFullApiUrl(methodConstants.LOGIN, currentState);
  Http.post(loginUrl, currentState, loginData).then((res) => {
    const accessToken = (res.token_type.replace(/^\w/, c => c.toUpperCase())) + ' ' + res.access_token;
    dispatch(ActionCreators.authToken(accessToken));
    dispatch(CommonActions.route(CommonActions.getFullApiUrl(appConstants.ROUTE_MOBILE_DEVICE, currentState)));
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
      dispatch(ActionCreators.displayLoader(false));
    });
};

export const logout = () =>(dispatch, getState) =>{
  const currentState = getState();
  let logoutUrl = CommonActions.getFullApiUrl(methodConstants.LOGOUT, currentState);
  logoutUrl = logoutUrl+appConstants.LOGOUT_ENDPOINT;
  window.open(logoutUrl, '_self');
};
